var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '../../../Typography';
import { useTheme } from '../../../../themes';
import Close from '../../../../assets/icons/CloseMark';
import * as S from './styles';
export var MultiSelectItemWrapper = function (_a) {
    var children = _a.children;
    return (_jsx(S.Container, { children: children }));
};
export var MultiSelectItem = function (_a) {
    var label = _a.label, onRemove = _a.onRemove, disabled = _a.disabled;
    var neutrals = useTheme().neutrals;
    var canRemove = disabled ? undefined : onRemove;
    return (_jsxs(S.Item, __assign({ "data-testid": "multi-select-item" }, { children: [_jsx(Typography, __assign({ color: neutrals.gray7, mRight: "nano", type: "p2" }, { children: label })), _jsx(Close, { "data-testid": "multi-select-remove-item", fill: neutrals.gray7, onClick: canRemove })] })));
};
